import { createSlice } from "@reduxjs/toolkit"

const shopSlice = createSlice({
    name: "shop",
    initialState: {
        shops: [],
        isFetching: false,
        error: null
    },
    reducers: {
        shopStart: (state) => {
            state.isFetching = true
        },
        shopFailure: (state, action) => {
            state.isFetching = false
            state.error = action.payload
        },
        getShopsSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.shops = action.payload
        },
        deleteShopSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.shops.splice(
                state.shops.findIndex((item) => item._id === action.payload),
                1
            )
        },
        updateShopSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.shops[state.shops.findIndex((item) => item._id === action.payload.id)] = action.payload.shops
        },
        createShopSuccess: (state, action) => {
            state.isFetching = false
            state.error = null
            state.shops.push(action.payload)
        }
    }
})

export const {
    shopStart,
    shopFailure,
    getShopsSuccess,
    deleteShopSuccess,
    updateShopSuccess,
    createShopSuccess } = shopSlice.actions

export default shopSlice.reducer
